import Grid from '../components/common/grid';
import List from '../components/common/list';
import { Container } from '../components/layout/container';
import Layout from '../components/layout/layout';
import { search } from '../lib/api';
import { useTranslation } from '../lib/i18n';
import { calcImageProps, COLLECTION_PREVIEW_LOGO_SIZE } from '../lib/images';

export default function BlogDetail({ items, preview }) {
  const { t } = useTranslation();
  return (
    <Layout preview={preview} title={t('weinguetertitle')}>
      <Container className='pt-4'>
        <div className='cmsRichText my-8 text-center leading-6'>
          <h1>{t('weinguetertitle')}</h1>
          <p>{t('weingueterlead')}</p>
        </div>
        <List listName={'blog'} items={items} Wrapper={Grid}></List>
      </Container>
    </Layout>
  );
}

export async function getStaticProps({ preview = false }) {
  const data = {
    items: (await search(`filter=categories--weingueter&sort=published--desc`))
      .results,
  };

  data.items.forEach((item) => {
    if (item.logo) {
      calcImageProps(item.logo, COLLECTION_PREVIEW_LOGO_SIZE);
    }
  });

  // sort by title
  data.items.sort((i1, i2) => (i1.title < i2.title ? -1 : 1));

  return {
    props: {
      ...data,
      preview,
    },
  };
}
